import React from "react";
import { useTranslation } from "react-i18next";

export default class FileViewerErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    console.error("FileViewerErrorBoundary caught error:", error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="card errorMessage" style={{ padding: "40px", textAlign: "center" }}>
          <h3>파일을 불러올 수 없습니다.</h3>
          <p>예상치 못한 오류가 발생했습니다.</p>
          <button
            type="button"
            className="btn-bg-blue"
            onClick={() => (window.location.href = "/admin/files")}
            style={{ marginTop: "20px" }}
          >
            목록으로 돌아가기
          </button>
        </div>
      );
    }

    return this.props.children;
  }
}
